import CommentStatus from './CommentStatus'

export default CommentStatus
